module.exports = __webpack_public_path__ + "static/media/money.ebb134f2.jpg";